import React, { useState } from 'react'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Helmet } from 'react-helmet'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getSingleDataFromDatabase } from '../utils/api'
import moment from 'moment'
import DashboardOverview from "../components/dashboard/DashboardOverview"
import DashboardSection from "../components/dashboard/DashboardSection"
import DashboardBarChart from "../components/dashboard/DashboardBarChart"
import DashboardGeoChart from "../components/dashboard/DashboardGeoChart"

const Dashboard = () => {
    const navigate = useNavigate();
    const subagentid = localStorage.getItem('subagentdata');
    const [subagent, setSubagent] = useState([]);

    useEffect(() => {
        if (subagentid) {
            getDashboardSingleEmpData(subagentid);
        } else {
            navigate("/");
        }
    }, [subagentid]);

    const getDashboardSingleEmpData = (subagentid) => {
        getSingleDataFromDatabase(`sub-agent-get-single-data/${subagentid}`).then((res) => {
            if (res.data.status === 1) {
                setSubagent(...[res.data.subagentdata]);
            } else {
                toast.error("Check your connection");
            }
        })
    }

    const greeting = () => {
        const hour = moment().hour();
        if (hour < 12) return "Good Morning";
        if (hour < 17) return "Good Afternoon";
        return "Good Evening";
    }

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR:SUB AGENT::DASHBOARD</title>
            </Helmet>
            <ContentWrapper>
                <h4 className="dashboardname">
                    {greeting()}, <span>{subagent?.subagent_name}</span>
                </h4>

                <div className="row" style={{marginBottom:"40px"}}>
                    {/* Stats Cards */}
                    <div className="col-12">
                        <DashboardSection />
                    </div>

                    {/* Overview Cards */}
                    <div className="col-12">
                        <DashboardOverview />
                    </div>

                    {/* Bar Chart */}
                    <div className="col-12 col-lg-8">
                        <DashboardBarChart />
                    </div>

                    {/* Geo Chart */}
                    <div className="col-12 col-lg-4">
                        <DashboardGeoChart />
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default Dashboard